import { AdMode } from "./AdTypes";

export type AdClasses = { [key: string]: string };

export function useAdClasses<TMobile extends AdClasses, TDesktop extends AdClasses>({
	mode = "responsive",
	mobileClasses,
	desktopClasses,
}: {
	mode?: AdMode;
	desktopClasses: TDesktop;
	mobileClasses: TMobile;
}) {
	return mode === "mobile" ? mobileClasses : mergeClasses(mobileClasses, desktopClasses);
}

function mergeClasses<TMobile extends { [key: string]: string }, TDesktop extends { [key: string]: string }>(
	mobile: TMobile,
	desktop: TDesktop,
): { [key in keyof TMobile]: string } {
	const result: { [key in keyof TMobile]: string } = { ...mobile };
	for (const key in desktop) {
		if (Object.prototype.hasOwnProperty.call(mobile, key)) {
			result[key] = [mobile[key], desktop[key]].filter(Boolean).join(" ");
		}
	}
	return result;
}
